export default {
  label: {
    rename: 'Renombrar',
    duplicate: 'Duplicar',
    delete: 'Eliminar',
  },
};
